export default __webpack_public_path__ + "static/media/sr-dashboard.3d5a6a30.png";